<template>
    <div>
        <Loader :loader="isLoadingAttribute" class="pt-4" />
        <div class="p-4">
            <div v-for="(attribute, index) in attributes" :key="attribute + index" class="animated fadeIn">
                <b-row class="alignment-fix">
                    <b-col class="col-md-2 col-sm-4">
                        <apexchart
                            width="200"
                            :options="updateColors(attribute.performance ? attribute.performance.progress : 0)"
                            :series="performanceProgress(attribute.performance ? attribute.performance.progress : 0)"
                        ></apexchart>
                    </b-col>
                    <b-col class="content-attribute padding: 0 !important col-12 col-md-9 col-lg-8">
                        <div class="d-flex align-items-center">
                            <b-form-input
                                @blur="savedNameAttribute(attribute.id, attribute.name, index)"
                                v-model="attributes[index].name"
                                :placeholder="$t('strategy.onepage.newAttribute.title')"
                                :disabled="!isCurrentUserVisible"
                            ></b-form-input>
                        </div>
                        <div class="d-flex align-items-center">
                            <b-form-input
                                @blur="savedDescriptionAttribute(attribute.id, attribute.description, index)"
                                v-model="attributes[index].description"
                                :placeholder="$t('strategy.onepage.newAttribute.description')"
                                :disabled="!isCurrentUserVisible"
                            ></b-form-input>
                        </div>
                        <div class="level-content">
                            <div>
                                <b-button
                                    :disabled="attribute.id ? !isCurrentUserVisible || false : true"
                                    class="button-okr py-2"
                                    :to="{
                                        path: 'link-okr',
                                        query: {
                                            onepageId: onepage.id,
                                            blockId: attribute.block_one_page_id,
                                            attributeId: attribute.id,
                                        },
                                    }"
                                >
                                    <div
                                        class="amount-okr"
                                        v-if="attribute.performance && attribute.performance.numberOfObjectives > 0"
                                    >
                                        {{ attribute.performance.numberOfObjectives }}
                                    </div>
                                    <span>
                                        <strong>{{ labelOkrLinked(attribute) }}</strong>
                                    </span>
                                </b-button>
                            </div>
                            <LevelCounter
                                @levelSelected="selectedLevelChallenge($event, attribute, index)"
                                :level="attribute.challenge_level"
                                :title="$t('strategy.onepage.levelCounter.challengeLevel')"
                                :amount="5"
                                icon="fas fa-circle"
                                type="number"
                                colorActive="#022B4F"
                                :currentUser="isCurrentUserVisible"
                            />
                            <LevelCounter
                                @levelSelected="selectedLevelPriority($event, attribute, index)"
                                :level="attribute.priority_level"
                                :title="$t('strategy.onepage.levelCounter.priorityLevel')"
                                :amount="5"
                                type="number"
                                icon="fas fa-circle"
                                colorActive="#009ADA"
                                :currentUser="isCurrentUserVisible"
                            />
                            <div class="horizon-input">
                                <span>{{ $t('strategy.onepage.horizons.title') }}</span>
                                <div v-if="hasValidHorizons">
                                    <b-form-select
                                        @change="updateHorizon($event, attribute.id)"
                                        :value="
                                            attribute.horizon_one_page_id == null ? 0 : attribute.horizon_one_page_id
                                        "
                                        :options="horizons"
                                        text-field="text"
                                        value-field="id"
                                        :disabled="!attribute.id || !isCurrentUserVisible"
                                    >
                                    </b-form-select>
                                </div>
                                <div v-else>
                                    <b-dropdown
                                        block
                                        class="dropHorizons"
                                        variant="white"
                                        :text="$t('strategy.onepage.horizons.noHorizonCreated')"
                                    >
                                        <b-dropdown-form class="p-4">
                                            <b-button @click="onSetupHorizons" variant="primary" size="md">
                                                <strong>{{ $t('strategy.onepage.horizons.createHorizons') }} </strong>
                                            </b-button>
                                        </b-dropdown-form>
                                    </b-dropdown>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <div v-if="isCurrentUserVisible" class="button-actions">
                        <div>
                            <router-link
                                :to="`/v2/strategy/onepage/permission-access?attributeId=${attribute.id}`"
                                class="button-setting"
                            >
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 23"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path :d="svg" fill="#BEC0C0" />
                                </svg>
                            </router-link>
                        </div>
                        <div class="d-flex align-items-start">
                            <TrashToDelete :attribute="attribute" @toDelete="deleteAttribute" />
                        </div>
                    </div>
                </b-row>
                <div class="divider"></div>
                <div class="mb-4" v-if="attributes.length == index + 1 && isCurrentUserVisible">
                    <b-button @click="createAttribute" variant="primary">
                        <strong>{{ $t('strategy.onepage.newAttribute.newStrategicAttribute') }}</strong>
                    </b-button>
                </div>
            </div>
        </div>
        <div v-if="loadingSaveAttribute" class="container-loading">
            <b-spinner style="width: 3rem; height: 3rem" variant="primary" label="Spinning"></b-spinner>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import StrategyService from '@/views/strategy/api'
import { LevelCounter, TrashToDelete } from './components'
import Loader from '@/views/components/loader'
import { newSvg } from '../pathSvg'

export default {
    name: 'NewAttibute',
    components: {
        LevelCounter,
        TrashToDelete,
        Loader,
    },
    props: ['pivot', 'existAttribute', 'attributesAll'],
    data() {
        return {
            attributes: [],
            selectedHorizon: null,
            loadingSaveAttribute: false,
            isLoadingAttribute: false,
            svg: newSvg,
        }
    },
    computed: {
        ...mapState('strategy', {
            onepage: (state) => state.onepage,
            validHorizons: ({ horizons }) => {
                return horizons.filter((oh) => !!oh.description)
            },
        }),
        horizons() {
            const selectDisabled = {
                id: 0,
                text: this.$t('strategy.onepage.horizons.selectHorizon'),
                value: null,
                disabled: true,
            }

            const horizons = this.validHorizons.map((horizon) => {
                return {
                    id: horizon.id,
                    text: `${horizon.horizon.type} - ${horizon.description}`,
                    value: horizon,
                }
            })

            horizons.push(selectDisabled)

            return horizons
        },
        hasValidHorizons() {
            return this.validHorizons.length > 0
        },
        isCurrentUserVisible() {
            const types = ['local_administrator', 'administrator', 'god']
            return types.includes(this.$store.getters.getCurrentUser.role.name)
        },
    },
    created() {
        this.strategyService = new StrategyService()
    },
    mounted() {
        this.attributes = this.attributesAll
    },
    methods: {
        ...mapActions('strategy', ['updateBlockAttributes']),
        createAttribute() {
            this.attributes.push({
                name: '',
            })
        },
        loadAttributes(id) {
            if (!this.loadingSaveAttribute) this.isLoadingAttribute = true
            this.strategyService
                .get_attributes(id, 'with=sections')
                .then(({ data }) => {
                    const body = { id, attributes: data }
                    this.attributes = data
                    this.updateBlockAttributes(body)
                })
                .finally(() => {
                    this.loadingSaveAttribute = false
                    this.isLoadingAttribute = false
                })
        },
        updateHorizon(e, attributeId) {
            this.strategyService.put_attribute_horizon(attributeId, {
                horizon_one_page_id: e,
            })
        },
        selectedLevelChallenge(e, { id }, index) {
            this.loadingSaveAttribute = true
            if (id) {
                this.strategyService
                    .put_attribute(id, {
                        challenge_level: e.rating,
                    })
                    .finally(() => {
                        this.loadAttributes(this.pivot.id)
                    })
            } else {
                this.strategyService
                    .post_attribute({
                        block_one_page_id: this.pivot.id,
                        challenge_level: e.rating,
                    })
                    .then(({ data }) => {
                        this.attributes[index] = data
                        this.loadAttributes(this.pivot.id)
                    })
            }
        },
        selectedLevelPriority(e, { id }, index) {
            this.loadingSaveAttribute = true
            if (id) {
                this.strategyService
                    .put_attribute(id, {
                        priority_level: e.rating,
                    })
                    .finally(() => {
                        this.loadAttributes(this.pivot.id)
                    })
            } else {
                this.strategyService
                    .post_attribute({
                        block_one_page_id: this.pivot.id,
                        priority_level: e.rating,
                    })
                    .then(({ data }) => {
                        this.attributes[index] = data
                        this.loadAttributes(this.pivot.id)
                    })
            }
        },
        savedNameAttribute(idAttribute, name, index) {
            this.loadingSaveAttribute = true
            if (name && name.length > 0) {
                if (idAttribute) {
                    this.strategyService.put_attribute(idAttribute, { name }).finally(() => {
                        this.loadAttributes(this.pivot.id)
                    })
                } else {
                    this.strategyService
                        .post_attribute({
                            block_one_page_id: this.pivot.id,
                            name,
                        })
                        .then(({ data }) => {
                            this.attributes[index] = data
                            this.loadAttributes(this.pivot.id)
                        })
                }
            } else {
                this.loadingSaveAttribute = false
            }
        },
        savedDescriptionAttribute(idAttribute, description, index) {
            this.loadingSaveAttribute = true
            if (description && description.length > 0) {
                if (idAttribute) {
                    this.strategyService
                        .put_attribute(idAttribute, {
                            description,
                        })
                        .finally(() => {
                            this.loadAttributes(this.pivot.id)
                        })
                } else {
                    this.strategyService
                        .post_attribute({
                            block_one_page_id: this.pivot.id,
                            description,
                        })
                        .then(({ data }) => {
                            this.attributes[index] = data
                            this.loadAttributes(this.pivot.id)
                        })
                }
            } else {
                this.loadingSaveAttribute = false
            }
        },
        deleteAttribute(attribute) {
            this.loadingSaveAttribute = true
            if (attribute.id) {
                this.strategyService.delete_attribute(attribute.id).then(() => {
                    this.loadAttributes(this.pivot.id)
                })
            } else if (attribute.id == undefined) {
                this.attributes.pop()
                this.loadAttributes(this.pivot.id)
            } else {
                this.loadingSaveAttribute = false
            }
        },
        onSetupHorizons() {
            this.$router.push('/v2/strategy/onepage/setup-horizons')
        },
        labelOkrLinked(attribute) {
            if (attribute.performance) {
                return attribute.performance.numberOfObjectives == 0
                    ? this.$t('strategy.okrs.link')
                    : attribute.performance.numberOfObjectives == 1
                    ? this.$tc('strategy.okrs.linked', 1)
                    : this.$tc('strategy.okrs.linked', 2)
            } else {
                return this.$t('strategy.okrs.link')
            }
        },
        performanceProgress(progress) {
            return [(progress * 100).toFixed(0)]
        },
        updateColors(progress) {
            let value = (progress * 100).toFixed(0)
            if (value == 0) {
                return this.updateColor('#999')
            } else if (value > 0 && value < 30) {
                return this.updateColor('#f05050')
            } else if (value >= 30 && value < 70) {
                return this.updateColor('#fad732')
            } else {
                return this.updateColor('#27c24c')
            }
        },
        updateColor(newColor) {
            return {
                colors: [newColor],
                chart: {
                    type: 'radialBar',
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -90,
                        endAngle: 260,
                        track: {
                            background: '#FFF',
                            strokeWidth: '100%',
                            margin: 4,
                            dropShadow: {
                                enabled: true,
                                top: 0,
                                left: 0,
                                color: newColor,
                                blur: 1,
                            },
                        },
                        hollow: {
                            margin: 1,
                            size: '55%',
                        },
                        dataLabels: {
                            name: {
                                show: false,
                            },
                            value: {
                                color: newColor,
                                fontSize: '24px',
                                show: true,
                                offsetY: 10,
                            },
                        },
                    },
                },
                labels: ['Progress'],
                states: {
                    normal: {
                        filter: {
                            type: 'none',
                        },
                    },
                    hover: {
                        filter: {
                            type: 'none',
                        },
                    },
                    active: {
                        allowMultipleDataPointsSelection: false,
                        filter: {
                            type: 'none',
                        },
                    },
                },
            }
        },
    },
}
</script>

<style lang="sass" scoped>
.alignment-fix
    justify-content: center !important;
    gap: 1rem
.container-loading
    width: 100vw
    height: 100vh
    z-index: 999
    position: fixed
    top: 0
    left: 0
    background: transparentize(#000, .8)
    display: flex
    justify-content: center
    align-items: center
.content-attribute
    padding: 0 !important
    display: flex
    flex-direction: column
    gap: 1rem
    .level-content
        display: flex
        flex-wrap: wrap-reverse
        justify-content: space-between
        gap: 1rem
        .button-okr
            display: flex
            align-items: center
            column-gap: .5rem
            background: #F9F9F9
            border: 1px solid #009ADA
            color: #009ADA
            .amount-okr
                border: 1px solid #009ADA
                border-radius: 50%
                background: #FFF
                color: #009ADA
                width: 25px
                height: 25px
            &:hover
                border: 1px solid #FFF
                background: #009ADA
                color: #FFF
        .horizon-input
            max-width: 300px
            width: 100%
            .dropHorizons
                width: 100%
                text-align: left
                background: #fff
                border: 1px solid #e4e5e6
                border-radius: 5px
        .text-validation
            font-size: .8rem
            padding: .4rem .2rem
.button-actions
    display: flex
    column-gap: 1rem
    div:first-child
        margin-top: 0.5rem
    div:nth-child(2)
        margin-top: 0.2rem
.divider
    margin: 2rem 0
    border-bottom: 2px solid #bec0c0

.button-setting
    display: flex
    align-items: flex-start
    font-size: 1.4rem
    padding: 0
    border: none
    &:hover
    background-color: transparent
    &:active
    border: none
@media screen and (max-width: 700px)
    .level-content
        flex-direction: column-reverse
        align-items: flex-end
        .button-okr
            width: 100%
        .horizon-input
            max-width: 100%
</style>
